import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './store/store';
import { getProfile } from './store/admin/admin.action';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LoginPage from './Pages/LoginPage';
import Dashboard from './Pages/Dashboard';
import SettingPage from './Pages/Settings/SettingPage';
import UserTablePage from './Pages/Users/UserTablePage';
import UsersFlagsPage from './Pages/UsersFlags/UsersFlagsPage';
import AdminProfilePage from './Pages/AdminProfile/AdminProfilePage';
import CoinPlanPage from './Pages/CoinPlan/CoinPlanPage';
import CoinHistoryPage from './Pages/CoinHistory/CoinHistoryPage';
import AuthGuard from './Components/Auth/AuthGuard';
import GuestGuard from './Components/Auth/GuestGuard';
import MainLayout from './Components/Layout/MainLayout';

const App = () => {
  const dispatch = useDispatch();
  const { isAuth } = useSelector(state => state.admin);

  useEffect(() => {
    // On app start, check if a token exists and validate it
    const token = localStorage.getItem('token');
    if (token && !isAuth) {
      dispatch(getProfile());
    }
  }, [dispatch, isAuth]);

  return (
    <>
      <ToastContainer />
      <Router>
        <Switch>
          <GuestGuard path="/login" component={LoginPage} />
          <Route path="/">
            <AuthGuard>
              <MainLayout>
                <Switch>
                  <Route exact path="/" component={Dashboard} />
                  <Route path="/settings" component={SettingPage} />
                  <Route path="/users" component={UserTablePage} />
                  <Route path="/users-flags" component={UsersFlagsPage} />
                  <Route path="/coin-plans" component={CoinPlanPage} />
                  <Route path="/coin-history" component={CoinHistoryPage} />
                  <Route path="/admin-profile" component={AdminProfilePage} />
                  <Redirect from="*" to="/" />
                </Switch>
              </MainLayout>
            </AuthGuard>
          </Route>
        </Switch>
      </Router>
    </>
  );
};

const AppWrapper = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default AppWrapper;